export const SET_CONTENT_TYPES = 'content-type/set-content-types';
export const REMOVE_CONTENT_TYPE = 'content-type/remove-content-type';
export const REMOVE_ATTRIBUTE = 'content-type/remove-attribute';
export const SET_ATTRIBUTES = 'content-type/set-attributes';
export const SET_SELECTED_CONTENT_TYPE = 'content-type/set-selected-content-type';
export const SET_SELECTED_ATTRIBUTE_FOR_CONTENTTYPE = 'content-type/set-selected-attribute-for-content-type';
export const SET_SELECTED_ATTRIBUTE = 'content-type/set-selected-attribute';
export const PUSH_PARENT_SELECTED_ATTRIBUTE = 'content-type/push-parent-selected-attribute';
export const POP_PARENT_SELECTED_ATTRIBUTE = 'content-type/pop-parent-selected-attribute';
export const MOVE_ATTRIBUTE_UP = 'content-type/move-attribute-up';
export const MOVE_ATTRIBUTE_DOWN = 'content-type/move-attribute-down';
export const SET_CONTENT_TYPE_REFERENCE_STATUS = 'content-type/set-reference-status';
export const SET_ACTION_MODE = 'content-type/set-action-mode';
export const REMOVE_ATTRIBUTE_FROM_COMPOSITE = 'content-type/remove-attribute-from-composite';
export const MOVE_ATTRIBUTE_FROM_COMPOSITE = 'content-type/move-attribute-from-composite';
export const SET_NEW_ATTRIBUTE_COMPOSITE = 'content-type/set-new-attribute-composite';
export const SET_SELECTED_NESTED_ATTRIBUTE = 'content-type/set-selected-nested-attribute';
